import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { ARRAY_MFG_REPORTS } from '@module-report/constants/report-type-lists';
import { ActionClaimModalGenerateReport } from '@module-claims/store/claims-modal.actions';
import { Select, Store } from '@ngxs/store';
import { IData, ReportState } from '@module-report/store/report.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-claim-report-modal',
  templateUrl: './claim-report-modal.component.html',
  styleUrls: ['./claim-report-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ClaimReportModalComponent implements OnInit {
  readonly reportTypes = ARRAY_MFG_REPORTS;

  form!: UntypedFormGroup;

  @Select(ReportState.reportGenerate)
  reportGenerate$!: Observable<IData<any>>;

  constructor(private _fb: UntypedFormBuilder, private _store: Store) {}

  ngOnInit(): void {
    this.form = this._fb.group({
      reportType: [null, [Validators.required]]
    });
  }

  get reportType(): AbstractControl {
    return this.form.get('reportType')!;
  }

  itemDisabled(itemArgs: { dataItem: any }): boolean {
    return itemArgs.dataItem.value === null;
  }

  generateReport(): void {
    if (this.reportType.invalid) {
      return;
    }

    this._store.dispatch(
      new ActionClaimModalGenerateReport(this.reportType.value, 'save')
    );
  }
}
